// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
// import './BookingForm.css'
// ##### Komarov 2025-05-26
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
// ##### 23-03-29 Komarov
import moment from 'moment';
import { useLocation } from 'react-router-dom';
// ##### 23-11-08 Komarov
import { Media } from '../../../helpers/MediaConfig';
// ##### 24-12-23 Komarov
import { encrypt } from '../../../helpers/crypto';
// ##### 25-05-21 Komarov
import ContentWrapperDiv from './ContentWrapperDiv';
// ##### 25-05-10 Komarov
import parse from 'html-react-parser';
import useValidateQuery from '../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const BookingForm = () => {
  // ##### Komarov 2025-07-12
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);
  // ##### Komarov 2025-08-05
  const BookingForm_Message_1 = useLocalizedText('BookingForm Message_1');
  const BookingRequest = useLocalizedText('BookingRequest');
  const CanxPolicySummary_2 = useLocalizedText('CanxPolicySummary_2');
  const CanxPolicySummary = useLocalizedText('CanxPolicySummary');
  const CanxPolicySummary_3 = useLocalizedText('CanxPolicySummary_3');
  const BookingWillBeCompleted = useLocalizedText('BookingWillBeCompleted');

  const location = useLocation();
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  const lastLocation = location.pathname + location.search;
  localStorage.setItem('lastLocation', lastLocation);

  localStorage.setItem('search_data', encrypt(search_data));
  // ##### 24-03-01 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);

  localStorage.setItem('cipherCompanyCipher', encrypt(company_cipher));

  // ##### Komarov 2025-07-21
  const date_difference = moment(search_data?.start).diff(
    moment(moment().format('YYYY-MM-DD')),
    'days'
  );

  let canx_deadline_date;

  if (
    parseInt(search_data?.service_type_id) === parseInt('11') &&
    parseInt(search_data?.nrf) === parseInt('0')
  ) {
    canx_deadline_date = moment(search_data?.start)
      .subtract(7, 'days')
      .calendar();
  } else if (
    parseInt(search_data?.service_type_id) === parseInt('1') &&
    parseInt(search_data?.nrf) === parseInt('0')
  ) {
    canx_deadline_date = moment(search_data?.start)
      .subtract(1, 'days')
      .calendar();
  } else if (parseInt(search_data?.nrf) === parseInt('1')) {
    canx_deadline_date = moment(search_data?.start).calendar();
  }

  const available_now = search_data?.available_now === 'true';

  return (
    <div className="FormWrapper" data-component="BookingForm">
      <h2>
        {
          // ##### Komarov 2025-07-02
          (available_now && BookingForm_Message_1) || BookingRequest
        }
      </h2>
      <h3 className="HeadPolicies">
        <span>
          {parseInt(search_data?.service_type_id) === parseInt('11') ? (
            date_difference < 7 ? (
              // ##### 23-10-06 Komarov: TODO: Взять перевод из Смарта
              <span>
                Your booking is for arrivals in less then 7 days. In case of
                cancellation, the fee will amount to 100% of the reservaton cost
              </span>
            ) : (
              <>
                <span style={{ marginRight: '5px' }}>
                  {
                    // ##### 23-10-04 Komarov
                    CanxPolicySummary_2
                  }
                  {/* ##### 23-11-09 Komarov */}
                  {/* <span style={{ marginLeft: '5px' }}>{moment(canx_deadline_date).format('YYYY-MM-DD')}</span> */}
                  <span style={{ marginLeft: '5px' }}>
                    {canx_deadline_date}
                  </span>
                </span>
                <span>
                  {
                    // ##### 23-10-04 Komarov
                    CanxPolicySummary
                  }
                </span>
              </>
            )
          ) : parseInt(search_data?.service_type_id) === parseInt('1') &&
            parseInt(search_data?.nrf) === parseInt('0') ? (
            // ##### Komarov 2025-07-02
            (available_now && (
              <>
                <span style={{ marginRight: '5px' }}>
                  {
                    // ##### 23-10-04 Komarov
                    CanxPolicySummary_2
                  }
                  {/* ##### 23-11-09 Komarov */}
                  {/* <span style={{ marginLeft: '5px' }}>{moment(canx_deadline_date).format('YYYY-MM-DD')}</span> */}
                  <span style={{ marginLeft: '5px' }}>
                    {canx_deadline_date}
                  </span>
                </span>
                <span>
                  {
                    // ##### 23-10-04 Komarov
                    CanxPolicySummary
                  }
                </span>
              </>
            )) || <span>{parse(BookingWillBeCompleted)}</span>
          ) : parseInt(search_data?.service_type_id) === parseInt('1') &&
            parseInt(search_data?.nrf) === parseInt('1') ? (
            // ##### Komarov 2025-07-02
            (available_now && (
              <>
                <span style={{ marginRight: '5px' }}>
                  {
                    // ##### 23-10-04 Komarov
                    CanxPolicySummary_2
                  }
                  {/* ##### 23-11-09 Komarov */}
                  {/* <span style={{ marginLeft: '5px' }}>{moment(canx_deadline_date).format('YYYY-MM-DD')}</span> */}
                  <span style={{ marginLeft: '5px' }}>
                    {canx_deadline_date}
                  </span>
                </span>
                <span>
                  {
                    // ##### 23-10-04 Komarov
                    CanxPolicySummary_3
                  }
                </span>
              </>
            )) || <span>{parse(BookingWillBeCompleted)}</span>
          ) : null}
        </span>
      </h3>
      {/* ##### Komarov 2025-05-26 */}
      <Media greaterThanOrEqual="Laptop-1024-1440" className="ContentWrapper">
        <ContentWrapperDiv formClassName="myForm" cartClass="CartDetails" />
      </Media>
      <Media lessThan="Laptop-1024-1440" className="ContentWrapperSmallScreen">
        <ContentWrapperDiv
          formClassName="myFormSmallScreen"
          cartClass="CartDetailsSmallScreen"
        />
      </Media>
    </div>
  );
};

export default BookingForm;
